import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { FormsModule, ReactiveFormsModule }    from '@angular/forms';
import { MatButtonModule }                     from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CsCommonPipesModule, CsCultureProvider } from '@cs/common';
import { CsSharedModule } from '@cs/components/shared';
import { LoggerUtil } from '@cs/core';
import { CsTranslationLoader, IConfigService } from '@cs/performance-manager/shared';
import { CsApplicationSettings } from '@cs/common';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { WizardModule } from '@cs/components/wizard';
import { WizardFormNxtModule } from '@cs/components/form-generator-nxt/plugins/wizard-form-nxt/wizard-form-nxt.module.module';
import { FormGeneratorNxtModule } from '@cs/components/form-generator-nxt';

import { RequestAccessConfigService } from './request-access-config.service';
import { RequestAccessRoutingModule } from './request-access-routing.module';
import { RequestAccessStepOneComponent } from './step-one/step-one.component';
import { RequestAccessStepTwoComponent } from './step-two/step-two.component';
import { RequestAccessConfirmationComponent } from './confirmation/confirmation.component';
import { WizardConfigService } from '@cs/components/wizard/services/wizard.service';

export function requestAccessTranslationLoader(client: HttpClient,
																							 pmAppSettings: CsApplicationSettings,
																							 service: IConfigService) {
	return new CsTranslationLoader(`${pmAppSettings.translationLocation}/${service.moduleName}`, client, null,
		pmAppSettings.deploymentDetails.buildDate);
}

@NgModule({
											imports: [
												CommonModule,
												ReactiveFormsModule,
												TranslateModule.forChild({
																																						loader : {
																																							provide   : TranslateLoader,
																																							useFactory: requestAccessTranslationLoader,
																																							deps      : [HttpClient, CsApplicationSettings, RequestAccessConfigService]
																																						},
																																						isolate: true
																																					}),
												MatButtonModule,
												MatCardModule,
												MatFormFieldModule,
												MatInputModule,
												MatSelectModule,
												MatProgressSpinnerModule,
												MatIconModule,
		RequestAccessRoutingModule,
		CsCommonPipesModule,
		CsSharedModule,
		WizardModule,
		FormGeneratorNxtModule,
		WizardFormNxtModule,
		FormsModule,
		MatTooltipModule
	],
	declarations: [RequestAccessStepOneComponent, RequestAccessStepTwoComponent, RequestAccessConfirmationComponent],
	providers: [

	]
})
export class PmRequestAccessModule {
	static forRoot(moduleConfig: Type<RequestAccessConfigService>,
									wizardConfig: Type<WizardConfigService>,
								 appSetting: CsApplicationSettings): ModuleWithProviders<PmRequestAccessModule> {
		return {
			ngModule: PmRequestAccessModule,
			providers: [
				{ provide: RequestAccessConfigService, useClass: moduleConfig },
				{ provide: CsApplicationSettings, useValue: appSetting },
				{ provide: WizardConfigService, useClass: wizardConfig }
			]
		};
	}

	constructor(translate: TranslateService, culture: CsCultureProvider) {

		if (!translate) {
			LoggerUtil.warn('Translation service is not set-up');
			return;
		}

		// this language will be used as a fallback when a translation isn't found in the current language for now hardcoded en
		translate.setFallbackLang(culture.getDefaultCulture());

		// the lang to use, if the lang isn't available, it will use the current loader to get them for now hardcoded en
		translate.use(culture.getCulture());
	}
}
